module.exports = __webpack_public_path__ + ".htaccess";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=.htaccess!./config/htaccess.conf
// module id = 5344
// module chunks = 0